import { HashRouter as Router } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Router basename={__BASE_PATH__}>
        <AppRoutes />
      </Router>
    </I18nextProvider>
  );
}

export default App;
